import React, { type FC } from 'react'

interface IconAngleDownSolidProps {
  width?: string
  height?: string
}

const IconAngleDownSolid: FC<IconAngleDownSolidProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 12"
      fill="none"
    >
      <path
        d="M4.7203 8.02949C5.01327 8.32246 5.48905 8.32246 5.78202 8.02949L9.53202 4.27949C9.82499 3.98652 9.82499 3.51074 9.53202 3.21777C9.23905 2.9248 8.76327 2.9248 8.4703 3.21777L5.24999 6.43809L2.02968 3.22012C1.73671 2.92715 1.26093 2.92715 0.967957 3.22012C0.674988 3.51309 0.674988 3.98887 0.967957 4.28184L4.71796 8.03184L4.7203 8.02949Z"
        fill="currentColor"
        shapeRendering="geometricPrecision"
      />
    </svg>
  )
}

export default IconAngleDownSolid
